import { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import { QrCode2 } from "@mui/icons-material";
import { v4 as uuid } from "uuid";
import QRDialog from "./QRDialog";
import {
  createMobileUploadApi,
  deleteMobileUploadApi,
  getMobileUploadStatusApi,
} from "../apis/mobile-upload.api";

const MobileScanner = ({ onUploaded }) => {
  const [open, setOpen] = useState(false);
  const [uploadId, setUploadId] = useState("");

  const intervalRef = useRef(null);

  const openScanner = async () => {
    try {
      const id = uuid();

      setUploadId(id);

      await createMobileUploadApi({ uploadId: id });

      setOpen(true);
    } catch (e) {
      console.log(e);
      alert("Unable to generate QR.");
    }
  };

  useEffect(() => {
    if (!open || !uploadId) return;

    intervalRef.current = setInterval(async () => {
      try {
        const response = await getMobileUploadStatusApi(uploadId);

        const data = response?.data?.data ?? response?.data ?? response;

        if (data?.status === "completed") {
          clearInterval(intervalRef.current);

          setOpen(false);

          onUploaded(data.url);

          try {
            await deleteMobileUploadApi(uploadId);
          } catch (e) {}
        }
      } catch (e) {}
    }, 2000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [open, uploadId]);

  const closeDialog = () => {
    clearInterval(intervalRef.current);
    setOpen(false);
  };

  return (
    <>
      <Button
        mt={2}
        disableElevation
        variant="contained"
        color="primary"
        startIcon={<QrCode2 />}
        onClick={openScanner}
        sx={{ flex: 1, minWidth: 0 }}
      >
        QR
      </Button>

      <QRDialog open={open} uploadId={uploadId} onClose={closeDialog} />
    </>
  );
};

export default MobileScanner;
